import React, { useState } from 'react';
import api from '../utils/api';
import './LeadForm.css';

const LeadForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    propertyInterest: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  // Handle input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    // Clear error message when user starts typing
    if (errorMessage) setErrorMessage('');
    if (submitStatus) setSubmitStatus(null);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage('');
    setSubmitStatus(null);

    try {
      await api.post('/api/leads', formData);
      
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phoneNumber: '',
        propertyInterest: ''
      });
      
      // Clear success message after 5 seconds
      setTimeout(() => {
        setSubmitStatus(null);
      }, 5000);
    } catch (error) {
      setSubmitStatus('error');
      setErrorMessage(
        error.response?.data?.error || 
        'Failed to submit form. Please try again later.'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const properties = [
    'Garnet Asokoro',
    'Garnet Ibeju Lekki'
  ];

  return (
    <section id="contact" className="lead-form-section section">
      <div className="container">
        <h2 className="section-title">Interested in Our Properties?</h2>
        <p className="section-subtitle">
          Fill out the form below and we'll get in touch with you
        </p>
        
        <div className="form-container">
          <form onSubmit={handleSubmit} className="lead-form card">
            <div className="form-group">
              <label htmlFor="name">Full Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Enter your full name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="Enter your email address"
              />
            </div>

            <div className="form-group">
              <label htmlFor="phoneNumber">Phone Number *</label>
              <input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
                placeholder="Enter your phone number"
              />
            </div>

            <div className="form-group">
              <label htmlFor="propertyInterest">Property Interest *</label>
              <select
                id="propertyInterest"
                name="propertyInterest"
                value={formData.propertyInterest}
                onChange={handleChange}
                required
              >
                <option value="">Select a property</option>
                {properties.map((property) => (
                  <option key={property} value={property}>
                    {property}
                  </option>
                ))}
              </select>
            </div>

            {submitStatus === 'success' && (
              <div className="alert alert-success">
                ✓ Thank you! Your information has been submitted successfully. We'll contact you soon.
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="alert alert-error">
                ✗ {errorMessage}
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default LeadForm;

